/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Duration_DaysInputs */

const en_task_duration_days = /** @type {(inputs: Task_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days`)
};

const pt_br2_task_duration_days = /** @type {(inputs: Task_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias`)
};

/**
* | output |
* | --- |
* | "days" |
*
* @param {Task_Duration_DaysInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_duration_days = /** @type {((inputs?: Task_Duration_DaysInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Duration_DaysInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_duration_days(inputs)
	return pt_br2_task_duration_days(inputs)
});